<!--
 * @Description: 隐私申明
 * @Author:  
 * @Date: 2022-05-11 10:13:58
 * @LastEditTime: 2022-05-17 14:33:02
 * @LastEditors:  
-->
<template>
  <div class="privacy">
    <div class="header">
      <div class="title">隐私声明</div>
      <hr>
    </div>
    <div class="content">
      <p>本隐私声明阐述了我们收集哪些关于您的信息、我们为何使用该等信息以及我们向谁提供该等信息。本声明同时载明您对您的信息的权利以及您若需了解更多信息或有疑问可联络的人。</p>
      <p>我们致力于保护您的隐私，并以公开和透明的方式处理您的信息。</p>
      <p>本隐私声明阐述了在您使用“动脉网网站”时我们如何收集、处理、存储和保护关于您的信息。
        就本隐私声明而言，“动脉网网站”或“本网站”是指URL从https://vbdata.cn/reportingDetail开始的特定网页</p>
      <p>在本隐私声明中，您的信息有时被称为“个人资料”或“个人信息”。有时我们也可能将处理、收集、保护和存储您的个人信息统称为“处理”该等个人信息。</p>
      <p>1、关于个人信息搜集<br>作为访问者，使用本网站并不需要提交任何个人信息。本网站只收集访问者明确、
      自愿提供的个人信息，包括姓名、公司或机构名称、职位、邮箱。我们收集的个人信息的类型可能取决于您如何使用我们的网站。</p>
      <p>2、关于个人信息使用<br>我们可以使用通过我们的网站收集的您的个人资料：（1）允许您访问特别内容或需要就感兴趣的特定领域与我们进行的沟通；
      （2）就向实体提供的服务、出于市场或其他研究目的寻求反馈意见。</p>
      <p>3、关于个人信息处理<br>基于我们供访问者有效使用本网站的合法权益或您明确同意我们处理该等资料，我们为上述列明目的使用您的个人资料。
      我们通常不要求访问者提供敏感信息，必要时我们将在获得您明确许可的前提下收集和使用该等信息。</p>
      <p>4、关于个人信息保护<br>我们采取一系列物理、电子和管理措施来确保我们保护您个人信息的安全、准确和更新。这些措施包括：
      （1）对相关工作人员进行教育和培训，以确保其在处理个人资料时意识到我们的隐私义务；
      （2）行政和技术控制措施，以限制仅在“需要知道”的基础上访问个人资料；
      （3）技术安全措施，包括防火墙、加密和杀毒软件；
      （4）物理安全措施，如进入我们工作场所的工作人员应有通行证。尽管我们一旦收到您的个人资料便采取适当的安全措施，然而通过互联网（包括电子邮件）
      传输资料向来无法做到彻底安全。我们将尽力保护个人资料，但我们无法保证向我们传输或由我们传输的资料的安全性。</p>
      <p>5、关于个人信息保存<br>保存在我们的系统中的您的个人资料，保存时间为下述最长期间：（i）相关行为所必需的时间或（ii）法律规定的任何保存期限。</p>
      <p>6、关于本隐私声明的修订<br>请您知悉并确认我们可能会不时修订本隐私声明。因此，您可以定期查阅本声明，以了解我们如何保护您的信息。咨询或投诉联系方式：023-67685030。</p>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="stylus" scoped>
  .privacy 
    width 1200px
    margin 30px auto 30px
    padding 40px 100px 58px
    background #FFFFFF
    .header
      width 100%
      text-align center
      // margin-top 40px
      .title
        font-size 20px
        font-weight bold
        color #333333
        margin-bottom 16px
      hr
        position absolute
        transform translateX(-50px)
        left 50%
        width 100px
        height 4px
        border none
        background #FF8824
    .content
      margin-top 44px
      p
        color #333
        font-size 14px
        line-height 22px
        text-align justify
        &:not(:first-child)
          margin-top 20px
        
</style>